// import React from 'react'
import SearchBar from '../SearchBar'

const Header = () => {
    return (
        <>
            <header className=' bg-secondaryBg sticky top-0'>
                <div className='flex items-center justify-between h-10 md:h-10 2xl:h-12 text-xs md:text-lg 2xl:text-xl w-[92%] md:w-full mx-auto md:divide-x md:divide-dividerLines'>
                    <div className='md:w-3/4 text-primaryText font-bold'>
                        <div>
                            <span className=' md:pl-8'>Device Debug</span>
                        </div>
                    </div>
                    <div className='md:w-1/4 justify-center md:p-2'>
                        <SearchBar />
                    </div>
                </div>
            </header>
        </>
    )
}

export default Header